import React from 'react';
import * as Styled from './list-item.styles';

// La signature des props de la librairie de matérial UI pose problème, il doit y avoir une issue à ce sujet, d'où le typage générique
export const ListItem = <T extends unknown>(props: T) => {
  return <Styled.ListItem button {...props} />;
};
